import Vue from 'vue';
import Router from 'vue-router';

// 导入页面组件
import LoginView from '@/views/LoginView.vue';
import LayoutView from '@/views/LayoutView.vue';
import DashboardView from '@/views/DashboardView.vue';
import WorkListView from '@/views/WorkListView.vue';
import RoleListView from '@/views/RoleListView.vue';
import TagListView from '@/views/TagListView.vue';
import WorkFormView from '@/views/WorkFormView.vue';
import RoleFormView from '@/views/RoleFormView.vue';
import WorkCoverView from '@/views/WorkCoverView.vue';
import NotFoundView from '@/views/NotFoundView.vue';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Layout',
    component: LayoutView,
    meta: { requiresAuth: true },
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardView
      },
      {
        path: 'works',
        name: 'WorkList',
        component: WorkListView
      },
      {
        path: 'roles',
        name: 'RoleList',
        component: RoleListView
      },
      {
        path: 'tags',
        name: 'TagList',
        component: TagListView
      },
      {
        path: 'work-form',
        name: 'WorkForm',
        component: WorkFormView
      },
      {
        path: 'role-form',
        name: 'RoleForm',
        component: RoleFormView
      },
      {
        path: 'work-cover',
        name: 'WorkCover',
        component: WorkCoverView
      },
      {
        path: '/role-form/:id?', // 允许id参数可选
        name: 'roleForm',
        component: RoleFormView
      }
    ]
  },
  {
    path: '*',
    component: NotFoundView
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !token) {
    next('/login?redirect=' + to.fullPath);
  } else if (to.path === '/login' && token) {
    next('/dashboard'); // 已登录用户访问登录页直接跳转到首页
  } else {
    next();
  }
});

export default router;